export default {
  locale: "en",
  name: "Close Booking Window",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      { fieldName: "startDate", displayName: "Start Date" },
      { fieldName: "endDate", displayName: "End Date" },
      { fieldName: "weekDays", displayName: "Days of the week" },
      { fieldName: "hourRange", displayName: "Hour Range" },
      { fieldName: "timeZone", displayName: "Time Zone" },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "closeBooking",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
